import { Box, Divider, IconButton } from '@dhl-ui/components'
import { usePage } from '../../context'
import { Facet } from './Facet'

export const Toggle = () => {
  const { isExpanded, setIsExpanded } = usePage()

  const toggle = () => {
    setIsExpanded(!isExpanded)
  }

  return (
    <Box
      sx={{
        position: 'sticky',
        inset: 'auto 0 0 0',
        textAlign: 'left',
        zIndex: 1,
        backgroundColor: 'background.paper',
      }}
    >
      <Divider />
      <Box
        sx={{
          pl: 1.5,
          py: 1,
        }}
      >
        {isExpanded ? (
          <IconButton
            size="small"
            onClick={toggle}
            sx={{ pl: 0.5 }}
            aria-label="contract"
            data-testid="page-side-menu-list-collapse"
          >
            <Facet inverse isOpen />
          </IconButton>
        ) : (
          <IconButton
            size="small"
            aria-label="expand"
            onClick={toggle}
            sx={{
              flexDirection: 'column',
              alignItems: 'center',
              py: 1,
              pl: 1,
            }}
            data-testid="page-side-menu-list-expand"
          >
            <Facet inverse />
          </IconButton>
        )}
      </Box>
    </Box>
  )
}
